import React from "react";
import { Link } from "react-router-dom";

const WhyChooseUsItem = (props) => {
  return (
    <div className="choose-item">
      <div className="choose-icon align-items-center">
        <div className="img-wrapper">
          <img
            src={props.item.src}
            alt={props.item.alt}
            style={{ maxWidth: "unset" }}
            className="w-60px"
          />
        </div>
        <div className="content-wrapper">
          <h2 className="title fs-6">
            <Link to={props.item.link}>{props.item.title}</Link>
          </h2>
        </div>
      </div>
      <div className="choose-content">
        <p>{props.item.description}</p>
      </div>
    </div>
  );
};

export default WhyChooseUsItem;
